import { render } from "./ContactDetail.vue?vue&type=template&id=e767e9f0&scoped=true"
import script from "./ContactDetail.vue?vue&type=script&lang=js"
export * from "./ContactDetail.vue?vue&type=script&lang=js"

import "./ContactDetail.vue?vue&type=style&index=0&id=e767e9f0&scoped=true&lang=css"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e767e9f0"]])

export default __exports__